/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect } from 'react';
import { VError } from 'verror';
import { getEventSubscriber } from '../api/websocket/eventSubscriber';
import { EventHandler, Subscription } from '../api/websocket/types';
import { diagnostics } from '@utils/diagnostics';

export interface UseEventSubscriberOptions {
  enabled?: boolean;
}

export function useWebsocketEventSubscriber<T>(
  channelUrl: string,
  handler: EventHandler<T>,
  { enabled = true }: UseEventSubscriberOptions = {},
): void {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    let stream: Subscription | undefined;
    try {
      const eventSubscriber = getEventSubscriber();
      stream = eventSubscriber.subscribeToEvent(channelUrl, handler);
    } catch (err) {
      diagnostics.error(new VError(err as Error, 'Error subscribing to websocket event'));
    }

    return () => stream?.cancel();
  }, [enabled]);
}
